/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {LayoutModule} from './layout-module';
export {BreakpointObserver, BreakpointState} from './breakpoints-observer';
export {Breakpoints} from './breakpoints';
export {MediaMatcher} from './media-matcher';



// WEBPACK FOOTER //
// ../../../../../src/cdk/layout/public-api.ts